export interface AssignmentFormData {
  practiceTopic: string
  grade: string
  classTime: string
  curriculum: string[]
  practiceType: string
  additionalConsiderations: string
}

export interface UploadedFileInfo {
  name: string
  size: number
  type: string
}

export const DEFAULT_ASSIGNMENT_VALUES: AssignmentFormData = {
  practiceTopic:
    "Create math problems about adding money amounts, incorporating reading comprehension skills",
  grade: "5th Grade",
  classTime: "30 minutes",
  curriculum: ["Great Minds"],
  practiceType: "Many Questions",
  additionalConsiderations: "",
}

export const INITIAL_FORM_VALUES: AssignmentFormData = {
  practiceTopic: "",
  grade: "",
  classTime: "",
  curriculum: [],
  practiceType: "",
  additionalConsiderations: "",
}
